Namespace 'Customer.Dashboard'

class Customer.Dashboard.SummaryBodyView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/summary_body']
  id: 'summary-list'
  className: 'microscroll scroll-y'

  initialize: ({tags}) ->
    super
    @tags = tags
    @summaryViews = []
    @ticketSummaries = new Customer.TicketSummaryCollection()
    @listenTo @ticketSummaries, 'tickets:loaded', @onTicketsLoaded
    @selectAllClicked = false
    @loadCompleted = false
    @ignoreResponse = false
    @includeNotLoaded = false

  render: =>
    @$el.html(@template())
    # the next binding is here because the 'backbone style' decalration its not working
    @$('.previous-results').on('click', @loadMoreResults)
    @preparePlaceholderContent()
    @summaryViews = []
    @ticketSummaries.each @_renderTicketSummary
    @toggleShowMore(@ticketSummaries.thereAreMore())
    if @loadCompleted
      @hidePlaceholderContent()
      @emptySummaries() unless @ticketSummaries.length > 0
    @

  _renderTicketSummary: (ticket) =>
    try
      ticket.select(true) if @selectAllClicked
      ticketSummaryView = new Customer.Dashboard.TicketSummaryView
        ticketSummary: ticket
      @listenTo(ticketSummaryView, 'counters:find:spin', @spinLoading)
      @listenTo(ticketSummaryView, 'counters:find:stop', @spinStop)
      @listenTo(ticketSummaryView, 'ticket:check', @checkTicket)
      @listenTo(ticketSummaryView, 'ticket:uncheck', @uncheckTicket)
      @summaryViews.push(ticketSummaryView)
      @$el.find('.summaries').append ticketSummaryView.render().$el
      ticketSummaryView.$el.find('input[type=checkbox]').prop('disabled', @selectAllClicked)
      @$el.find('#conversations_no_results').hide()
    catch error
      jsLogger.fatal "Ticket summary can't be initialized: #{JSON.stringify error} - #{error.stack}"
      console.error error

  loadMoreResults: =>
    @$el.find('.show-previous-results').hide()
    @$el.find('.loading-previous-results-spinner').show()
    @trigger('dashboard:summary:previous-results')

  toggleShowMore: (thereAreMore) =>
    @$el.find('.previous-results').toggle(thereAreMore)

  spinLoading: =>
    @trigger('counters:find:spin')

  spinStop: =>
    @trigger('counters:find:stop')

  toggleSelectAll: (checked) =>
    @selectLoadedClicked = checked
    @$el.find('.summaries').find('.summary-select-box-container').find('input[type=checkbox]')
      .prop('checked', @selectLoadedClicked)
      .change()
    if @selectLoadedClicked
      @ticketSummaries.selectAll()
    else
      @ticketSummaries.unselectAll()

  setIncludeNotLoaded: (state) ->
    @includeNotLoaded = state

  checkTicket: ->
    @trigger('ticket:check')

  uncheckTicket: ->
    @trigger('ticket:uncheck')

  selectedSummaries: () ->
    @ticketSummaries.selected()

  loadedSummaries: () ->
    @ticketSummaries.totalLoaded()

  search: (filter) ->
    @ticketSummaries.load({filter: filter, tags: @tags})

  loadMore: ({filter, page_number}) ->
    @ticketSummaries.loadMore({filter: filter, page_number: page_number, tags: @tags})

  onTicketsLoaded: (total, tickets, reset) =>
    unless @ignoreResponse
      @showGetMore()
      @emptySummaries() if reset
      @hidePlaceholderContent()
      @trigger('tickets:loaded', total, tickets, reset)
      @loadCompleted = true
      @render()
      @setCheckState()

  setCheckState: ->
    if @includeNotLoaded
      @$el.find('.summaries').find('input[type=checkbox]').prop('checked', true)

  emptySummaries: =>
    @$el.find('.summaries').empty()
    @$el.find('#conversations_no_results').show()
    _.each @summaryViews, (view) -> view.remove()
    @summaryViews = []

  setIgnoreResponse: (status) ->
    @ignoreResponse = status

  preparePlaceholderContent: =>
    headerHeight = 135
    summarySectionHeight = window.innerHeight - headerHeight
    placeholderHeight = Customer.Dashboard.SummaryTicketPlaceholderView.contentHeight
    placeholderAmount = Math.floor(summarySectionHeight / placeholderHeight) + 1
    @_appendNewPlaceholderContent() for [1..placeholderAmount]

  _appendNewPlaceholderContent: ->
    placeholderView = new Customer.Dashboard.SummaryTicketPlaceholderView()
    @$el.find('.placeholder-summaries').append(placeholderView.render().$el)

  showPlaceholderContent: =>
    @$el.find('.summaries').fadeOut(
      duration: 'slow',
      complete: @_showPlaceholderSummaries()
    )

  _showPlaceholderSummaries: =>
    @$el.find('.summaries').empty()
    @$el.find('.placeholder-summaries').fadeIn('slow')

  hidePlaceholderContent: =>
    @$el.find('.placeholder-summaries').fadeOut(
      duration: 'fast',
      complete: @_showRealSummaries()
    )

  _showRealSummaries: =>
    @$el.find('.summaries').fadeIn('slow')

  hideGetMore: =>
    @$('.previous-results').hide()

  showGetMore: =>
    @$('.previous-results').show()

  setSearchingState: =>
    @setIgnoreResponse(false)
    @showPlaceholderContent()
    @hideGetMore()

  unsetSearchingState: =>
    @setIgnoreResponse(true)
    @hidePlaceholderContent()
    @showGetMore()

  displayContent: =>
    if @loadCompleted
      @hidePlaceholderContent()

  resetLoadCompleted: ->
    @loadCompleted = false
